import React, { useState } from "react";
import {
  PreviousPaperModel,
  PreviousPaperQuestionsModel,
} from "../../../../models/ExamModels/PreviousPaperModel/previouspaper.model";
import { PreviousPaperService } from "../../../../services/ExamService/PreviousPaperService/previouspaper.service";
import CardMenu from "../../../../shared/components/CourseComponents/CardMenu";
import DeleteAlert from "../../../../shared/components/DeleteAlert";
import ToggleSwitch from "../../../../shared/components/ToggleSwitch";
import DisplayExercise from "../../../CourseStructure/Chapters/DisplayExercise";
import { AddPaper } from "../AddPaper";
import { DisplayPaper } from "../DisplayPaper";
import "./paperCards.scss";
interface PaperCardsProps {
  papers: PreviousPaperModel[];
  refreshList: Function;
  examId: any;
  currentPageNumber: number
}
export const PaperCards = ({
  papers,
  refreshList,
  examId,
  currentPageNumber
}: PaperCardsProps) => {
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [currentContent, setCurrentContent] = useState<any>(null);

  const handleDelete = () => {
    PreviousPaperService.deletePreviousPaper(
      currentContent.id,
      () => {
        setDeleteVisible(false);
        if(refreshList) refreshList(currentPageNumber);
      },
      () => {}
    );
  };

  const handleStatusToggle = (id: any, checked: boolean) => {
    PreviousPaperService.updatePreviousPaper(
      id,
      {
        isActive: checked,
      },
      () => {
        if(refreshList) refreshList(currentPageNumber)
      },
      () => {}
    );
  };

  return (
    <div className="paper-cards">
      <AddPaper
        currentPageNumber={currentPageNumber}
        examId={examId}
        paper={currentContent}
        refreshList={refreshList}
        visible={editFormVisible}
        closeModalHandler={() => setEditFormVisible(false)}
      />
      <DisplayPaper
        visible={showContent}
        paper={currentContent}
        closeModal={() => {
          setShowContent(false);
        }}
      />
      <DeleteAlert
        title={currentContent?.title}
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText="Paper"
        deleteWarning={"This paper will be deleted permanently?"}
        handleDelete={handleDelete}
      />
      {papers.map((value: PreviousPaperModel, index: number) => {
        return (
          <div
            className="paper__card"
            onClick={(e) => {
              setCurrentContent(value);
              setShowContent(true);
              console.log(currentContent);
            }}
          >
            <div className="paper__details">
              <div className="paper__title">{value?.title}</div>
              <div className="paper__date">
                {value.month} {value.year} <span className="details-separator"/> ID: {value?.id}
              </div>
            </div>
            <div
              className="paper__toggle"
              onClick={(event) => event.stopPropagation()}
            >
              <ToggleSwitch
                checked={value.isActive ? value.isActive : false}
                handleChange={(checked: boolean) => {
                  handleStatusToggle(value.id, checked);
                }}
              />
            </div>
            <div
              className="paper-menu__trigger"
              onClick={(event) => {
                event.stopPropagation();
                setCurrentContent(value);
              }}
            >
              <CardMenu
                menuText="Paper"
                handleEdit={setEditFormVisible}
                handleDelete={setDeleteVisible}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};
